import { render, staticRenderFns } from "./TaxPlanTile.vue?vue&type=template&id=0bf2e59a&scoped=true&"
import script from "./TaxPlanTile.vue?vue&type=script&lang=js&"
export * from "./TaxPlanTile.vue?vue&type=script&lang=js&"
import style0 from "./TaxPlanTile.vue?vue&type=style&index=0&id=0bf2e59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2e59a",
  null
  
)

export default component.exports